import dayjs from 'utils/dayjs';
// Event tray in mobile web is shown based on the variables below
const EVENTS_COUNT_GREATER_THAN_CONSTANT = 5;
const EVENTS_HAPPENING_IN_X_NEXT_DAYS = 30;
export const MIN_EVENTS_TO_SHOW_CHANGE_EVENT_BUTTON = 2;
export const shouldShowEventsTrayInMobile = ({ events = [], isEventListEnabled = false, timezone, eventsHappeningInXNextDays = EVENTS_HAPPENING_IN_X_NEXT_DAYS, eventsCountGreaterThanConstant = EVENTS_COUNT_GREATER_THAN_CONSTANT, }) => {
    const TODAY = dayjs().tz(timezone);
    const MAX_LIMIT_DAY = dayjs()
        .tz(timezone)
        .add(eventsHappeningInXNextDays, 'day');
    return (isEventListEnabled &&
        (events.length > eventsCountGreaterThanConstant ||
            events.some(event => dayjs(event.starts)
                .tz(timezone)
                .isBetween(TODAY, MAX_LIMIT_DAY, 'day', '[]'))));
};
